module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAA8CAYAAABMxmv5AAAAAXNSR0IArs4c6QAAABlJREFUKFNjfPH2x38GBgYGxlHGaCCgpgQAVEDkDe7OsLMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/home/line2.png
// module id = I25t
// module chunks = 1